import { rangeCount } from '@startuptools/common/transactions';
import { type GqlShareRange } from '../../../graphql/base-types.graphql';

export function nosPerClass(
  shareRanges:
    | Pick<GqlShareRange, 'shareClass' | 'start' | 'end'>[]
    | Pick<GqlShareRange, 'shareClass' | 'start' | 'end'>[],
) {
  return shareRanges.reduce(
    (res, r) => {
      const nos = res[r.shareClass.name] ?? 0;
      res[r.shareClass.name] = nos + rangeCount(r.start, r.end);
      return res;
    },
    {} as Record<string, number>,
  );
}
